import { useMutation } from 'react-query';
import { BASE_URL } from '../../../constants/endpoints';
import { httpService } from '../../../services/http.service';
import { useStore } from '../../../store';
import { IPostLinkData, IServerErrorResponse } from '../../../types';

export enum LinkTokenType {
  LIMITED_ACH = 'LIMITED_ACH',
  ACH = 'ACH',
  DEPOSIT_SWITCH = 'DEPOSIT_SWITCH',
  ACH_AND_TRANSACTIONS = 'ACH_AND_TRANSACTIONS',
  TRANSACTIONS = 'TRANSACTIONS',
}

export const useLinkCustomertoPlaid = (linkTokenType: LinkTokenType, errorHandler: (e: IServerErrorResponse) => void) => {
  const { customerId } = useStore((state) => state.user);

  return useMutation('useLinkCustomertoPlaid', async (plaidData: IPostLinkData) => {
    const { publicToken, metaData } = plaidData;
    const institutionId = metaData?.institution?.institution_id;

    const { data } = await httpService.post(`${BASE_URL}/api/v2/user/${customerId}/link`, {
      publicToken,
      metaData: JSON.stringify(metaData),
      linkTokenType,
      institutionId,
    });
    return data;
  }, { onError: (e: IServerErrorResponse) => errorHandler(e) });
};
